import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { INCIDENT_GRAPHQL_DETAIL } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { getIncidentDetailQuery } from '../api';
import type { IncidentDetail } from '../types';

const useIncidentDetails = (incidentId?: string) => {
  const selectedEnvId = useSelectedEnv();

  const { data, isLoading, isFetching, error } = useGraphqlQuery<{
    incidentV2: IncidentDetail;
  }>({
    queryKey: [INCIDENT_GRAPHQL_DETAIL, incidentId, selectedEnvId],
    query: getIncidentDetailQuery,
    variables: { id: incidentId },
    enabled: !!incidentId,
  });

  return {
    isLoading,
    isFetching,
    data: data?.incidentV2,
    error,
  };
};

export default useIncidentDetails;
